<template>
  <ODialog ref="dialog" :maxWidth="400">
    <v-card>
      <v-card-text class="d-flex flex-wrap py-3 px-0">
        <div
          class="w-1/2 d-flex align-center justify-space-between px-6 py-3"
          v-for="row in iconTags"
          :key="row.tag"
        >
          <span>{{ row.tag }}</span>
          <span :class="row.icon" style="font-size: 1.5em" />
        </div>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
const iconTags = [
  { tag: 'Empilhadeira', icon: 'od-forklift' },
  { tag: 'MaquinaEletrica', icon: 'od-reacher' },
  { tag: 'Rebocador', icon: 'od-tug' },
  { tag: 'Trem', icon: 'od-train' },
  { tag: 'Onibus', icon: 'od-bus' },
  { tag: 'Basculante', icon: 'od-dump' },
  { tag: 'Munck', icon: 'od-munck' },
  { tag: 'Pipa', icon: 'od-water-truck' },
  { tag: 'Betoneira', icon: 'od-mixer' },
  { tag: 'Niveladora', icon: 'od-motor-grader' },
  { tag: 'Motoniveladora', icon: 'od-motor-grader' },
  { tag: 'Prancha', icon: 'od-lowboy' },
  { tag: 'Carregadeira', icon: 'od-loader' },
  { tag: 'TratorEsteira', icon: 'od-bulldozer' },
  { tag: 'Comboio', icon: 'od-refuel' },
  { tag: 'Plataforma', icon: 'od-platform' },
  { tag: 'Caminhonete', icon: 'od-pickup' },
  { tag: 'Carro', icon: 'od-car' },
  { tag: '(default)', icon: 'od-truck' }
]

export default {
  data() {
    return { iconTags }
  },
  methods: {
    open() {
      this.$refs.dialog.$open()
    }
  }
}
</script>

<style></style>
